import React from 'react';
import ReactTooltip from 'react-tooltip';
import { Loader, BaasicTable, BaasicConfirmModal, TableFilter, BaasicHeader, BaasicTableExport } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { fileNames } from 'common/constants';
import { ReceivingExpandList } from 'modules/receiving/pages';

const ReceivingManualListTemplate = ({
	viewStore,
	viewStore: {
		listStore,
		tableData,
		queryUtility,
		loading,
		baasicTableSettingsViewStore,
		expandChange,
		headerCell,
		change,
		columnFilterSetup,
		removeFiltersModal,
	},
	actions,
}) => {
	if (loading) return <Loader />;
	return (
		<section className="layout__main__body">
			<BaasicHeader title="MAINMENU.CONTAINERS.TITLE" baasicTableSettingsViewStore={baasicTableSettingsViewStore}>
				<BaasicTableExport tableViewStore={viewStore} fileTitle={fileNames.receivingManual} />
			</BaasicHeader>
			<BaasicTable
				{...{
					listStore,
					tableData,
					queryUtility,
					actions,
					headerCell,
					change,
					expandChange,
					detailComponent: ReceivingExpandList,
					viewStore,
				}}
				data={listStore.data.slice()}
			/>
			<TableFilter viewStore={viewStore} columnFilterSetup={columnFilterSetup} />
			<BaasicConfirmModal modalParams={removeFiltersModal.removeFiltersConfirm} />
			<ReactTooltip />
		</section>
	);
};

export default defaultTemplate(ReceivingManualListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/receiving/pages/manual/ReceivingManualListTemplate.jsx